import { createAsyncThunk } from '@reduxjs/toolkit';

import { type FetchPlayerConfigParams, PlayerConfigFetcher } from '../../api/fetchers/playerConfig/fetcher';

interface FetchPlayerConfigActionParams extends FetchPlayerConfigParams {
  essential: boolean;
}

export const fetchPlayerConfigAction = createAsyncThunk(
  'playerConfig/fetchPlayerConfig',
  (params: FetchPlayerConfigActionParams) => PlayerConfigFetcher.fetch(params)
);
